import React, { useCallback } from 'react';
import { FormInstance, List, Row } from 'antd';
import ICatalog from 'icons/ICatalog';
import getEnvValue from 'utils/getEnvValue';
import ButtonOperation from 'components/ButtonOperation';
import AssetCard from './AssetCard';
import {
  AssetCatalogResponse,
  ParAssetCatalogOptionResponse,
  ParAssetCatalogServiceResponse,
} from 'services/assetconfig';

export type AssetsCardTableProps = {
  currcode?: string;
  assets: any[];
  reftechProp?: () => void;
  onAddFromCatalog?: () => void;
  onAddFromCatalogPack?: () => void;
  onAddFromStock?: () => void;
  onAddInitAsset?: () => void;
  onCreateNewAsset?: () => void;
  onCreateNewMultiCompAsset?: () => void;
  onDelete: (asset: any) => void;
  onMoveToNewelement: (asset: any) => void;
  // onSelect?: (asset: any) => void;
  onSelectOptions: (option: any, cteid: number, assetid: number,operation:string) => void;
  onSelectServices: (service: any, cteid: number, assetid: number,operation:string) => void;

  ctfclevel?: string;
  phase: 'PROD' | 'PROPOSAL';
  flagreal: boolean;
  onSaveAsset?: (asset: any) => void;
  ctrid?: number;
  title?: string;
  fromproposal?: boolean;
  proposalData?: any;
  mfuse?: boolean;
  assetCatalog?: boolean;
  showActionButton?: boolean;
  hideSaveBtnAsset?: boolean;
  ctstatus?: string;
  nbreAsset?: any;
  form: FormInstance;
  elementID: number;
  // recalculate: any;
  debouncedCalculateNew: any;
  handleConvertServToFinServ: any;
  handleDeleteElement: any;
  onSaveService: any;
  onSelect: (
    item: AssetCatalogResponse,
    nbasset: number,
    selectedServices?: ParAssetCatalogServiceResponse[],
    selectedOption?: ParAssetCatalogOptionResponse[],
    fromCatalogMulticomponents?: boolean
  ) => void;
};

const AssetsCardTable = (props: AssetsCardTableProps) => {
  const {
    assets,
    onAddFromCatalog,
    onAddFromCatalogPack,
    onCreateNewAsset,
    onCreateNewMultiCompAsset,
    onAddFromStock,
    onAddInitAsset,
    onDelete,
    onMoveToNewelement,
    onSelect,
    ctfclevel = 'PROPOSAL',
    phase = 'PROPOSAL',
    flagreal,
    onSaveAsset,
    currcode,
    ctrid,
    title,
    reftechProp,
    fromproposal,
    proposalData,
    mfuse,
    assetCatalog,
    showActionButton,
    hideSaveBtnAsset,
    ctstatus,
    nbreAsset,
    form,
    // recalculate,
    debouncedCalculateNew,
    handleConvertServToFinServ,
    handleDeleteElement,
    onSaveService,
    onSelectOptions,
    onSelectServices
  } = props;

  const compareNbreAsset = nbreAsset
    ? parseInt(nbreAsset.parvaluemin) <= assets?.length
    : false;

  const handleSelect = useCallback(
    (
      item,
      nbasset,
      selectedServices,
      selectedOption,
      fromCatalogMulticomponents
    ) => {
      onSelect(
        item,
        nbasset,
        selectedServices,
        selectedOption,
        fromCatalogMulticomponents
      );
    },
    [onSelect]
  );

  return (
    <>
      <Row justify="end" gutter={30}>
        {phase === 'PROPOSAL' && mfuse === false && onAddFromStock && (
          <ButtonOperation
            comcode="AddFromStock"
            icon={<ICatalog />}
            type="default"
            onClick={onAddFromStock}
            custom={{ height: 45, marginRight: 10 }}
            disabled={compareNbreAsset}
          />
        )}
        {phase === 'PROPOSAL' && mfuse === false && onAddFromCatalog && (
          <ButtonOperation
            comcode="addFromCatalog"
            icon={<ICatalog />}
            type="default"
            onClick={onAddFromCatalog}
            custom={{ height: 45, marginRight: 10 }}
            disabled={compareNbreAsset}
          />
        )}

        {phase === 'PROPOSAL' && mfuse === false && onAddFromCatalogPack && (
          <ButtonOperation
            comcode="addAssetPack"
            icon={<ICatalog />}
            type="default"
            onClick={onAddFromCatalogPack}
            custom={{
              height: 45,
              backgroundColor: getEnvValue('secondarycolor'),
              color: 'white',
              marginRight: 10,
            }}
            disabled={compareNbreAsset}
          />
        )}
      </Row>
      <List
        style={{ marginTop: '10px' }}
        dataSource={form?.getFieldValue('assets') ?? []}
        grid={{
          gutter: 16,
          xs: 1,
          sm: 1,
          md: 1,
          lg: 1,
          xl: 1,
          xxl: 1,
        }}
        pagination={{ pageSize: 12 }}
        rowKey="assetid"
        renderItem={(e: any) => {
          let elements = form.getFieldValue('elements')

          const {
            FIN
          } = elements;

          let record = FIN?.find((elem:any)=>elem.cteid===e.cteid)
          return(
          <List.Item>
            <AssetCard
              item={e}
              //onSelect={handleSelectAssetFromCatalog}
              record={record}
              form={form}
              debouncedCalculateNew={debouncedCalculateNew}
              phase={phase}
              ctrid={ctrid}
              ctstatus={ctstatus}
              fromproposal={fromproposal}
              proposalData={proposalData}
              handleConvertServToFinServ={handleConvertServToFinServ}
              handleDeleteElement={handleDeleteElement}
              onSelect={handleSelect}
              onSelectOptions={(e, cteid, assetid,operation) => {
                onSelectOptions(e, cteid, assetid,operation);
              }}
              onSaveAsset={onSaveAsset}
              onSelectServices={function (
                service: any,
                cteid: number,
                assetid: number,
                operation:string
              ): void {
                onSelectServices(service, cteid, assetid,operation);
              }} // recalculate={(
              //   duration: number,
              //   rvamount: number,
              //   cteid: number
              // ) => recalculate(duration, rvamount)}
            />
          </List.Item>)
        }}
      />
    </>
  );
};

export default AssetsCardTable;
